/**
 * La tipografía de las secciones de la landing del vídeo, en un solo sitio: la
 * usan las fichas, la prueba (componente de cliente) y el resto de secciones.
 * Solo constantes, así que se puede importar desde un `'use client'`.
 */
export const SECTION_TITLE = 'text-center font-christmas text-4xl font-bold leading-tight md:text-5xl'

export const SECTION_LEAD = 'mx-auto mt-4 max-w-2xl text-center text-lg text-white/85'

/**
 * El chip ámbar del momento de cada vídeo («Antes de la carta · …»), en la
 * landing y en los cross-sells. Centrado y con `text-wrap: balance`: en móvil
 * el momento del libro parte en dos líneas y así quedan parejas, en vez de una
 * larga y una palabra huérfana.
 */
export const MOMENT_CHIP = 'rounded-full bg-amber-200 px-3 py-0.5 text-center text-sm font-semibold text-red-900 [text-wrap:balance]'
